export default __webpack_public_path__ + "static/media/2.709bec3e.png";